import React, { forwardRef } from 'react';
import {
  Input as AntdInput,
  type InputRef as AntdInputRef,
  type InputProps as AntdInputProps,
} from 'antd';

const InputBase = forwardRef<AntdInputRef, AntdInputProps>((props, ref) => (
  <AntdInput {...props} ref={ref} />
));

const Input = InputBase as typeof InputBase & {
  OTP: typeof AntdInput.OTP;
  Search: typeof AntdInput.Search;
  TextArea: typeof AntdInput.TextArea;
  Password: typeof AntdInput.Password;
};

Input.OTP = AntdInput.OTP;
Input.Search = AntdInput.Search;
Input.TextArea = AntdInput.TextArea;
Input.Password = AntdInput.Password;

Input.displayName = 'Input';

export type InputRef = AntdInputRef;
export type InputProps = AntdInputProps;

export { Input };
